import CONSTANTS from "core/constants";
import {
  theme as defaultTheme,
  Icon,
  Tooltip,
  RadioGroup,
} from "@mindlercare/ui-web";
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Typography } from "components/typography";
import { RadioButtonWrapper, RadioLabel } from "./styled";

const StyledLabel = styled(Typography).attrs({
  variant: "body-x-small",
})`
  color: ${({ theme }) => defaultTheme.COLORS.GRAY_DARK};
`;

const TypeSelector = ({ onFormFieldChange, formData }) => {
  const { t } = useTranslation();

  return (
    <div>
      <StyledLabel>{t("TYPE")}</StyledLabel>
      <RadioButtonWrapper>
        <RadioGroup
          defaultValue={formData.type}
          onChange={(value) => {
            onFormFieldChange("type", value);
          }}
          pt={7}
        >
          <RadioGroup.RadioButton name={CONSTANTS.CERTIFICATE}>
            <RadioLabel>{t("CERTIFICATE")}</RadioLabel>
            <Tooltip content={t("CERTIFICATE_FORM_TEXT")}>
              <Icon.Info color="SECONDARY" />
            </Tooltip>
          </RadioGroup.RadioButton>
          <RadioGroup.RadioButton name={CONSTANTS.REFERRAL}>
            <RadioLabel>{t("REFERRAL")}</RadioLabel>
            <Tooltip content={t("REFERRAL_FORM_TEXT")}>
              <Icon.Info color="SECONDARY" />
            </Tooltip>
          </RadioGroup.RadioButton>
        </RadioGroup>
      </RadioButtonWrapper>
    </div>
  );
};

TypeSelector.propTypes = {
  t: PropTypes.func,
  formData: PropTypes.object,
  onFormFieldChange: PropTypes.func,
  getSmallPrint: PropTypes.func,
};

export default withTranslation()(TypeSelector);
